import React from 'react';
import Payment from 'payment';
import PropTypes from 'prop-types';
import { propTypes } from 'redux-form';

import Field from '../../../../common/input';
import SaveButton from '../../../../common/buttons/saveButton';
import CancelButton from '../../../../common/buttons/cancelButton';

class DebitCardFrom extends React.Component {
  componentDidMount() {
    const { form } = this.props;
    Payment.formatCardNumber(document.querySelector(`form[name="${form}"] input[name="number"]`));
    Payment.formatCardExpiry(document.querySelector(`form[name="${form}"] input[name="exp"]`));
    Payment.formatCardCVC(document.querySelector(`form[name="${form}"] input[name="cvc"]`));
  }

  prepare = (data) => {
    const { save, currency } = this.props;
    const forSave = {};
    const { month, year } = Payment.fns.cardExpiryVal(data.exp);
    forSave.number = data.number.replace(/ /g, '');
    forSave.exp_month = month;
    forSave.exp_year = year;
    forSave.currency = currency;
    forSave.cvc = data.cvc;

    return save(forSave);
  };

  render() {
    const { handleSubmit, cancel, submitting, form } = this.props;

    return (
      <form name={form} onSubmit={handleSubmit(this.prepare)}>
        <fieldset disabled={submitting}>
          <div className="layout u-mt u-max-width-430 u-margin-auto">
            <div className="layout__item">
              <div className="c-label-new">
                Number
              </div>
              <Field
                name="number"
                className="c-input"
                component="input"
                type="text"
              />
            </div>
            <div className="layout__item u-1/2">
              <div className="c-label-new">
                Expiration (mm/yy)
              </div>
              <Field
                name="exp"
                className="c-input"
                component="input"
                type="text"
              />
            </div>
            <div className="layout__item">
              <div className="c-label-new">
                CVC
              </div>
              <Field
                name="cvc"
                className="c-input"
                component="input"
                type="text"
              />
            </div>
            <div className="layout__item u-text-center">
              <CancelButton
                content="Cancel"
                onClick={cancel}
              />
              <SaveButton content="Save" />
            </div>
          </div>
        </fieldset>
      </form>
    );
  }
}

DebitCardFrom.propTypes = {
  save: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  ...propTypes,
};

export default DebitCardFrom;
